<template>
  <div class="auth-container">
    <div class="card card-container">
      <h1>Prijava</h1>
      <Form @submit="handleLogin" :validation-schema="schema">
        <div class="form-group">
          <label for="username">Uporabniško ime</label>
          <Field name="username" type="text" class="form-control" />
          <ErrorMessage name="username" class="error-feedback" />
        </div>
        <div class="form-group">
          <label for="password">Geslo</label>
          <Field name="password" type="password" class="form-control" />
          <ErrorMessage name="password" class="error-feedback" />
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
            ></span>
            <span>Prijava</span>
          </button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
      <div class="auth-links">
        <p><router-link to="/register">Še nimate računa? Registracija</router-link></p>
        <p><router-link to="/forgot-password">Ste pozabili geslo?</router-link></p>
        <p><router-link to="/">Nazaj na domačo stran</router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Uporabniško ime je obvezno!"),
      password: yup.string().required("Geslo je obvezno!"),
    });

    return {
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    userRoles() {
      return this.$store.state.auth.user?.roles || [];
    },
  },
  created() {
    if (this.loggedIn) {
      if (this.userRoles.includes('ROLE_ADMIN')) {
        this.$router.push("/admin");
      } else if (this.userRoles.includes('ROLE_PARTNER')) {
        this.$router.push("/admin");
      } else if (this.userRoles.includes('ROLE_USER')) {
        this.$router.push("/ads");
      } else {
        this.$router.push("/profile");
      }
    }
  },
  methods: {
    async handleLogin(values) {
      this.loading = true;
      this.message = "";

      try {
        await this.$store.dispatch("auth/login", values);
        if (this.userRoles.includes("ROLE_ADMIN")) {
          this.$router.push("/admin");
        } else if (this.userRoles.includes("ROLE_PARTNER")) {
          this.$router.push("/admin");
        } else if (this.userRoles.includes("ROLE_USER")) {
          this.$router.push("/ads");
        } else {
          this.$router.push("/profile");
        }
      } catch (error) {
        this.message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
